export enum ReportType {
  report = 'report',
  dashboard = 'dashboard',
  tile = 'tile',
  visual = 'visual',
  qna = 'qna',
}
